import { useTranslations } from "next-intl";
import { useState, useEffect } from "react";
import { getFaqCategory } from "@utils/call-api/help-call";
import FaqArticlesList from "@components/views/Help/FaqArticlesList";

function ReferralFaq() {
  const t = useTranslations("referrals");

  const [faqArticles, setFaqArticles] = useState([]);

  useEffect(() => {
    async function fetchFaq() {
      const faqReferralSlug =
        process.env.NEXT_PUBLIC_CUSTOMER === "lgd" ? "parrainage" : "marrainage";
      const res = await getFaqCategory(faqReferralSlug);
      const first5Articles = res.articles.slice(0, 5);
      setFaqArticles(first5Articles);
    }

    fetchFaq();
  }, []);

  return (
    <div>
      <div
        style={{ maxWidth: "540px" }}
        className="w-100 mx-auto pb-7 px-3"
      >
        <h4 className="mb-4 pb-2 text-center">{t("faq_title")}</h4>

        <FaqArticlesList
          faqArticles={faqArticles}
          firstArticleOpen
        />
      </div>
    </div>
  );
}

export default ReferralFaq;
